"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Noun_User = void 0;

Noun_User = function () {
	function Noun_User() {
		return (0, _jquery2.default)("#user-config").data("user-object");
	}

	return Noun_User;
}();

exports.default = Noun_User();